import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { matCloseOutline } from '@ng-icons/material-icons/outline';
import { matPhone, matEmail, matInfo } from '@ng-icons/material-icons/baseline';
import { ModalState } from '../../state-stores/modal-state.state';

@Component({
  selector: 'app-contactus',
  imports: [FormsModule, TranslocoModule, NgIconComponent],
  templateUrl: './contactus.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [provideIcons({ matCloseOutline, matPhone, matEmail, matInfo })]
})
export class ContactusComponent implements OnInit, OnDestroy {
  @Input() onCancel!: () => void;

  contactForm = {
    subject: '',
    message: ''
  };

  constructor(private readonly modalState: ModalState) {}

  ngOnInit(): void {
    this.modalState.setModalOpen(true);
  }

  ngOnDestroy(): void {
    this.modalState.setModalOpen(false);
  }

  onCancelClicked(): void {
    this.onCancel();
  }

  onSubmit(): void {
    // TODO: Implement form submission logic
    // This will be implemented later to handle the contact form submission
    console.log('Contact form submitted:', this.contactForm);
    
    // For now, just close the modal
    this.onCancel();
  }
}
